import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  Stack,
  Card,
  Typography,
  Paper,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import {
  useGetallGradeQuery,
  useGetallSubjectQuery,
  useCreateSubjectAddGradeMutation,
  useCreateSubjectRemovedGradeMutation,
} from "../../../Api/attoDeskApi";
import {
  IApiResponse,
  IGrade,
  IStudentLocation,
  ISubject,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import NewPopUpSubject from "../Create/subject";
import { GiCheckMark } from "react-icons/gi";
import NewPopUpGradem from "../Create/grade";
import { FieldArray, FormikProvider, useFormik } from "formik";
import ClassessList from "../Create/classList";
import SubjectList from "../Create/subjectList";
import BackDrop from "../../../Components/Loader/BackDrop";

const Item = styled(Paper)(({ theme }) => ({
  width: "100%",
  display: "block",
  padding: theme.spacing(1.5),
  borderRadius: "8px",
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.2s ease",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const ItemList = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "selected",
})<{ selected?: boolean }>(({ theme, selected }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(1, 2),
  borderRadius: 8,
  cursor: "pointer",
  transition: "all 0.2s ease",
  boxShadow: "none",

  backgroundColor: selected
    ? theme.palette.primary.main
    : theme.palette.background.paper,

  color: selected ? "#ffffff" : theme.palette.text.primary,

  "& .MuiTypography-root": {
    color: selected ? "#ffffff" : theme.palette.text.primary,
  },

  "&:hover": {
    // boxShadow: theme.shadows[3],
    backgroundColor: selected
      ? theme.palette.primary.dark
      : theme.palette.action.hover,
  },
}));

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const [refreshKey, setRefreshKey] = useState(0);
  const [handelGradeId, setHandelGradeId] = useState<number | null>(null);

  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const isMobileRes = useIsMobile();
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [selectedCoursing, setSelectedCoursing] =
    useState<IStudentLocation | null>(null);

  const [selectedenum, setSelectedEnum] = useState<ISubject | null>(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openCreateDialogEnum, setOpenCreateDialogEnum] = useState(false);
  const [openEditDialogEnum, setOpenEditDialogEnum] = useState(false);

  const [openCreateDialogGrade, setOpenCreateDialogGrade] = useState(false);
  const [openEditDialogGrade, setOpenEditDialogGrade] = useState(false);
  const [selectedenumGrade, setSelectedGrade] = useState<IGrade | null>(null);

  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<IStudentLocation | null>(null);

  const [selectedType, setSelectedType] = useState<number | null>(null);
  const [selectedenumTypeList, setSelectedTypeList] = useState<IGrade | null>(
    null
  );

  const [addtitle, setAddtitle] = useState("");
  const [addSubTitle, setAddSubTitle] = useState("");
  const [openAddGrade, setOpenAddGrade] = useState(false);
  const [selectedAddGrade, setSelectedAddGrade] = useState<ISubject | null>(
    null
  );
  const [addActions, setActions] = useState("");

  const [selectedSubjects, setSelectedSubjects] = useState<ISubject[]>([]);
  const [unSelectedSubjects, setUnSelectedSubjects] = useState<ISubject[]>([]);

  const [newCompany, { isLoading: addsubjectLoading }] =
    useCreateSubjectAddGradeMutation();

  const [newRemoved, { isLoading: removedsubjectLoading }] =
    useCreateSubjectRemovedGradeMutation();

  const { data, isLoading, isError, refetch } = useGetallGradeQuery({
    searchText: "",
  });

  const {
    data: subjectData,
    isLoading: subjectIsLoading,
    refetch: subjectRefetch,
  } = useGetallSubjectQuery({
    searchText: currentSearchQuery,
  });

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleOpenCraeteDialogEnum = () => {
    setOpenCreateDialogEnum(true);
    setHandelGradeId(selectedType);
  };

  const handleCloseCreateDialogEnum = () => {
    setOpenCreateDialogEnum(false);
  };

  const handleOpenCraeteDialogGrade = () => {
    setOpenCreateDialogGrade(true);
  };

  const handleCloseCreateDialogGrade = () => {
    setOpenCreateDialogGrade(false);
  };

  const handleOnclicGradeChange = (enumType: IGrade) => {
    setSelectedTypeList(enumType);
    setSelectedType(enumType.id);
  };

  const coursings: IGrade[] = Array.isArray(data?.data)
    ? (data?.data as IGrade[])
    : [];

  const subjectDataList: ISubject[] = Array.isArray(subjectData?.data)
    ? (subjectData?.data as ISubject[])
    : [];

  // const selectedSubjects = subjectDataList.filter((item) =>
  //   selectedenumTypeList?.subject_ids?.includes(item.id)
  // );

  // const unSelectedSubjects = subjectDataList.filter(
  //   (item) => !selectedenumTypeList?.subject_ids?.includes(item.id)
  // );

  useEffect(() => {
    if (coursings.length > 0 && selectedType === null) {
      setSelectedType(coursings[0].id);
      setSelectedTypeList(coursings[0]);
    }
  }, [coursings]);

  useEffect(() => {
    if (coursings.length === 0) return;

    const gradeToSelect =
      handelGradeId !== null && handelGradeId !== undefined
        ? coursings.find((c) => c.id === handelGradeId) || coursings[0]
        : coursings[0];

    setSelectedType(gradeToSelect.id);

    setSelectedTypeList(gradeToSelect);
  }, [coursings, handelGradeId]);

  const formik = useFormik({
    initialValues: {
      subject_id: selectedAddGrade?.id || selectedType || null,
      grade_id: selectedenumTypeList?.id || null,
    },
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let response: IApiResponse | null = null;

      try {
        const payload = {
          subject_id: values.subject_id,
          grade_id: values.grade_id,
        };

        if (addActions === "Add") {
          response = await newCompany(payload).unwrap();
        } else if (addActions === "Removed") {
          response = await newRemoved(payload).unwrap();
        }

        if (!response?.status) {
          showErrorMessage(response?.message || "Action failed");
          return;
        }

        showMessage(response.message);
        handleCloseaddGradeChange();

        if (addActions === "Add") {
          setSelectedTypeList((prev: any) => ({
            ...prev,
            subject_ids: [...prev.subject_ids, values.subject_id],
          }));
        } else {
          setSelectedTypeList((prev: any) => ({
            ...prev,
            subject_ids: prev.subject_ids.filter(
              (id: number) => id !== values.subject_id
            ),
          }));
        }
        resetForm();
      } catch (error) {
        console.error(error);
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.subject_id === null ||
      formik.values.subject_id === null
      ? false
      : true;
  }, [formik]);

  const handleaddGradeChange = (enumType: ISubject, action: string) => {
    setSelectedAddGrade(enumType);
    setOpenAddGrade(true);
    setAddSubTitle("Are you sure you want to add subject");
    setAddtitle("Add subject");
    setActions(action);
    formik.setFieldValue("subject_id", enumType.id);
  };

  const handleCloseaddGradeChange = () => {
    setSelectedAddGrade(null);
    setOpenAddGrade(false);
    setAddSubTitle("");
    setAddtitle("");
    setActions("");

    formik.setFieldValue("subject_id", null);
  };

  useEffect(() => {
    if (!subjectDataList || !selectedenumTypeList) {
      setSelectedSubjects([]);
      setUnSelectedSubjects([]);
      return;
    }

    const selected = subjectDataList.filter((item) =>
      selectedenumTypeList.subject_ids?.includes(item.id)
    );

    const unselected = subjectDataList.filter(
      (item) => !selectedenumTypeList.subject_ids?.includes(item.id)
    );

    setSelectedSubjects(selected);
    setUnSelectedSubjects(unselected);
  }, [
    subjectDataList,
    selectedenumTypeList,
    addsubjectLoading,
    removedsubjectLoading,
  ]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={3} md={4} sm={12} xs={12}>
            <Card
              className={classes.card}
              sx={{ height: "100%" }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 2, py: 1.5,
                  borderBottom: "1px solid rgba(0,0,0,0.08)",
                }}
              >
                <Typography sx={{ fontSize: 14, fontWeight: 600 }}>Grade</Typography>
                <Button
                  className={classes.addNewButton}
                  size="small"
                  onClick={handleOpenCraeteDialogGrade}
                >
                  Add New
                </Button>
              </Box>

              <Box sx={{ p: 1.5 }}>
                <Box
                  sx={{
                    maxHeight: isMobileRes ? "200px" : "calc(100vh - 320px)",
                    overflow: "auto",
                    "&::-webkit-scrollbar": { width: "3px" },
                    "&::-webkit-scrollbar-thumb": { background: "#d0d0d0", borderRadius: "4px" },
                  }}
                >
                  <Stack spacing={1} width="100%">
                        {isLoading ? (
                          <Grid>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              height="10vh"
                            >
                              {/* <CircularProgress sx={{ fontSize: "14px" }} /> */}
                              <Typography variant="subtitle1">
                                Loading..
                              </Typography>
                            </Box>
                          </Grid>
                        ) : isError || coursings.length === 0 ? (
                          <Typography textAlign={"center"}>
                            {isError
                              ? "Error fetching data"
                              : "No data available"}
                          </Typography>
                        ) : (
                          coursings.map((item: IGrade) => {
                            const isActive = selectedType === item.id;

                            return (
                              <Item
                                key={item.id}
                                sx={{
                                  background: isActive
                                    ? theme.palette.primary.main
                                    : "#eef2f7",

                                  color: isActive
                                    ? "#ffffff"
                                    : theme.palette.primary.main,
                                }}
                                // onClick={() => setSelectedType(item.id)}
                                onClick={() => handleOnclicGradeChange(item)}
                              >
                                <Typography
                                  sx={{
                                    color: isActive
                                      ? "#ffffff"
                                      : theme.palette.primary.main,
                                    fontWeight: 600,
                                  }}
                                >
                                  {item.grade}
                                </Typography>
                              </Item>
                            );
                          })
                        )}
                      </Stack>
                    </Box>
                  </Box>
            </Card>
          </Grid>

          <Grid item lg={9} md={8} sm={12} xs={12}>
            <Card className={classes.card} sx={{ height: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  px: 2, py: 1.5,
                  borderBottom: "1px solid rgba(0,0,0,0.08)",
                }}
              >
                <Button
                  className={classes.addNewButton}
                  size="small"
                  onClick={handleOpenCraeteDialogEnum}
                >
                  Add New
                </Button>
              </Box>
              <Box
                sx={{
                  p: 2,
                  maxHeight: isMobileRes ? "300px" : "calc(100vh - 320px)",
                  overflow: "auto",
                  "&::-webkit-scrollbar": { width: "3px" },
                  "&::-webkit-scrollbar-thumb": { background: "#d0d0d0", borderRadius: "4px" },
                }}
              >
                <Grid container spacing={1}>
                  {(isLoading || subjectIsLoading) && (
                    <Grid item xs={12}>
                      <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                        <Typography variant="subtitle1">Loading..</Typography>
                      </Box>
                    </Grid>
                  )}
                  {selectedSubjects.map((item: ISubject) => (
                    <Grid item key={item.id}>
                      <ItemList
                        selected={true}
                        onClick={() => handleaddGradeChange(item, "Removed")}
                        sx={{ cursor: "pointer", background: theme.palette.primary.main, color: "#ffffff" }}
                      >
                        <GiCheckMark style={{ marginRight: "8px", fontWeight: 600, color: "#ffffff" }} />
                        <Typography sx={{ color: "#ffffff" }}>{item.subject_name || "-"}</Typography>
                      </ItemList>
                    </Grid>
                  ))}
                  {unSelectedSubjects.map((item: ISubject) => (
                    <Grid item key={item.id}>
                      <ItemList
                        selected={false}
                        onClick={() => handleaddGradeChange(item, "Add")}
                        sx={{ cursor: "pointer", background: "#eef2f7", color: theme.palette.primary.main }}
                      >
                        <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                          {item.subject_name || "-"}
                        </Typography>
                      </ItemList>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Card>
          </Grid>

          <Grid item lg={3} md={4} sm={12} xs={12}>
            <Card className={classes.card} sx={{ width: "100%", height: "100%" }}>
              <ClassessList />
            </Card>
          </Grid>
          <Grid item lg={9} md={8} sm={12} xs={12}>
            <Card className={classes.card} sx={{ width: "100%", height: "100%" }}>
              <SubjectList />
            </Card>
          </Grid>
        </Grid>
      </Grid>

      {openCreateDialogEnum && (
        <NewPopUpSubject
          openModel={openCreateDialogEnum}
          handleCloseDialog={handleCloseCreateDialogEnum}
          onSuccess={(newParent) => {
            setRefreshKey((prev) => prev + 1);
          }}
          get_grade_id={Number(selectedType)}
        />
      )}

      {openCreateDialogGrade && (
        <NewPopUpGradem
          openModel={openCreateDialogGrade}
          handleCloseDialog={handleCloseCreateDialogGrade}
        />
      )}

      <Dialog
        open={openAddGrade}
        onClose={handleCloseaddGradeChange}
        sx={{ padding: 5, minWidth: 450 }}
      >
        <Grid className={isMobileRes ? classes.DialogMobile : classes.Dialog}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              pt={2}
              alignContent={"center"}
            >
              <Typography className={classes.cardTitle}>
                {addActions === "Removed" ? "Remove Subject" : "Add Subject"}
              </Typography>
            </Grid>
          </Grid>
          <DialogContent>
            <DialogContentText sx={{ pt: 3 }}>
              {addActions === "Removed"
                ? "Are you sure you want to remove this subject from the selected grade?"
                : "Are you sure you want to add this subject to the selected grade?"}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              className={classes.addButton}
              onClick={handleCloseaddGradeChange}
            >
              Cancel
            </Button>
            <Box m={0.2}></Box>

            <Button
              variant="contained"
              className={classes.addButton}
              onClick={() => formik.handleSubmit()}
              disabled={
                !formValid || addsubjectLoading || removedsubjectLoading
              }
            >
              {(addsubjectLoading || removedsubjectLoading) && (
                <CircularProgress
                  size={18}
                  className={classes.isLoading}
                  sx={{ marginRight: 1 }}
                />
              )}
              {addActions}
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
    </Grid>
  );
};

export default Index;
